import { render } from "./ChangeAttendanceExpires.vue?vue&type=template&id=1c00f0ce&scoped=true&lang=pug"
import script from "./ChangeAttendanceExpires.vue?vue&type=script&lang=js"
export * from "./ChangeAttendanceExpires.vue?vue&type=script&lang=js"

import "./ChangeAttendanceExpires.vue?vue&type=style&index=0&id=1c00f0ce&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c00f0ce"]])

export default __exports__